// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FAB__container-f5fb6b {
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: var(--border-radius);
  padding: 0;
  color: var(--color);
  background-color: var(--background-color);
  border: var(--border);
  box-shadow: var(--box-shadow);
  text-decoration: none;
}

.FAB__container-f5fb6b:hover {
  color: var(--color-hover);
  background-color: var(--background-color-hover);
  box-shadow: var(--box-shadow-hover);
}

@supports (display: block) {
  .FAB__container-f5fb6b:focus-visible {
    color: var(--color-focus);
    background-color: var(--background-color-focus);
    box-shadow: var(--box-shadow-focus);
  }
}
.FAB__container-f5fb6b:focus-within {
  color: var(--color-focus);
  background-color: var(--background-color-focus);
  box-shadow: var(--box-shadow-focus);
}

.FAB__container-f5fb6b:active {
  color: var(--color-active);
  background-color: var(--background-color-active);
  box-shadow: var(--box-shadow-active);
}

.FAB__container-f5fb6b:disabled {
  color: var(--color-disabled);
  background-color: var(--background-color-disabled);
  box-shadow: var(--box-shadow-disabled);
  cursor: default;
  border: var(--border-disabled);
}

.FAB__badge-abd503 {
  position: absolute;
  width: 24px;
  height: 24px;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  color: var(--addition-50);
  background-color: var(--brand-primary-40);
  transition: border-color 0.3s ease;
  font: var(--font-caption-1);
  letter-spacing: var(--font-spacing-caption-1);
  display: inline-block;
  line-height: 24px;
  text-align: center;
}

.FAB__icon-e8966d {
  fill: currentColor;
}

:root[dir=rtl] .FAB__icon-e8966d {
  transform: scaleX(-1);
}

.FAB__size-0-b42b1c {
  width: 24px;
  height: 24px;
}

.FAB__icon-size-0-ef0fa9 svg {
  width: 16px;
  height: 16px;
}

.FAB__size-10-f5b024 {
  width: 32px;
  height: 32px;
}

.FAB__icon-size-10-dc3786 svg {
  width: 24px;
  height: 24px;
}

.FAB__size-20-aabbfc {
  width: 36px;
  height: 36px;
}

.FAB__icon-size-20-cce7b5 svg {
  width: 24px;
  height: 24px;
}

.FAB__size-30-a1d052 {
  width: 40px;
  height: 40px;
}

.FAB__icon-size-30-e52a78 svg {
  width: 24px;
  height: 24px;
}

.FAB__size-40-a845c2 {
  width: 48px;
  height: 48px;
}

.FAB__icon-size-40-e83670 svg {
  width: 24px;
  height: 24px;
}

.FAB__size-50-b14226 {
  width: 52px;
  height: 52px;
}

.FAB__icon-size-50-d57319 svg {
  width: 24px;
  height: 24px;
}

.FAB__size-60-bf9848 {
  width: 64px;
  height: 64px;
}

.FAB__icon-size-60-ad2cee svg {
  width: 32px;
  height: 32px;
}

.FAB__theme-1-d5f50f {
  --border-radius: 50%;
  --color: var(--brand-primary-40);
  --background-color: transparent;
  --color-hover: var(--brand-primary-40);
  --background-color-hover: var(--base-20);
  --color-focus: var(--brand-primary-40);
  --background-color-focus: var(--base-20);
  --color-active: var(--brand-primary-50);
  --background-color-active: var(--base-30);
  --color-disabled: var(--brand-primary-20);
  --background-color-disabled: transparent;
}

.FAB__theme-2-b15042,
.FAB__theme-8-ce1bc2 {
  --border-radius: 50%;
  --color: var(--base-120);
  --background-color: var(--base-0);
  --color-hover: var(--base-120);
  --background-color-hover: var(--base-20);
  --color-focus: var(--base-120);
  --background-color-focus: var(--base-20);
  --color-active: var(--base-120);
  --background-color-active: var(--base-30);
  --color-disabled: var(--base-40);
  --background-color-disabled: var(--base-0);
}

.FAB__theme-2-b15042 {
  --background-color: transparent;
}

.FAB__theme-2_1-a90f20,
.FAB__theme-8_1-a66eab {
  --border-radius: 50%;
  --color: var(--base-120);
  --background-color: var(--base-30);
  --color-hover: var(--base-120);
  --background-color-hover: var(--base-20);
  --color-focus: var(--base-120);
  --background-color-focus: var(--base-20);
  --color-active: var(--base-120);
  --background-color-active: var(--base-30);
  --color-disabled: var(--base-40);
  --background-color-disabled: var(--base-0);
}

.FAB__theme-2_i-c1681b {
  --border-radius: 50%;
  --color: var(--addition-50);
  --background-color: var(--addition-110);
  --color-hover: var(--addition-50);
  --background-color-hover: var(--addition-110);
  --color-focus: var(--addition-50);
  --background-color-focus: var(--addition-110);
  --color-active: var(--addition-50);
  --background-color-active: var(--addition-110);
  --color-disabled: var(--addition-50_50);
  --background-color-disabled: var(--base-0);
}

.FAB__theme-3-ce1c66 {
  --border-radius: 50%;
  --color: var(--base-120);
  --background-color: transparent;
  --color-hover: var(--base-120);
  --background-color-hover: var(--base-20);
  --color-focus: var(--base-120);
  --background-color-focus: var(--base-20);
  --color-active: var(--base-120);
  --background-color-active: var(--base-30);
  --color-disabled: var(--base-40);
  --background-color-disabled: var(--base-0);
}

.FAB__theme-3_1-c75193 {
  --border-radius: 50%;
  --color: var(--base-80);
  --background-color: transparent;
  --color-hover: var(--base-100);
  --background-color-hover: transparent;
  --color-focus: var(--base-100);
  --background-color-focus: transparent;
  --color-active: var(--base-120);
  --background-color-active: transparent;
  --color-disabled: var(--base-60);
  --background-color-disabled: transparent;
}

.FAB__theme-3_2-f32996 {
  --border-radius: 50%;
  --color: var(--brand-primary-40);
  --background-color: transparent;
  --color-hover: var(--brand-primary-50);
  --background-color-hover: transparent;
  --color-focus: var(--brand-primary-50);
  --background-color-focus: transparent;
  --color-active: var(--brand-primary-60);
  --background-color-active: transparent;
  --color-disabled: var(--brand-primary-10);
  --background-color-disabled: transparent;
}

.FAB__theme-6-b87e82 {
  --border-radius: 50%;
  --color: var(--base-120);
  --background-color: var(--base-20);
  --color-hover: var(--base-120);
  --background-color-hover: var(--base-30);
  --color-focus: var(--base-120);
  --background-color-focus: var(--base-30);
  --color-active: var(--base-120);
  --background-color-active: var(--base-40);
  --color-disabled: var(--base-60);
  --background-color-disabled: var(--base-20);
}

.FAB__theme-7-f8af48 {
  --border-radius: 50%;
  --color: var(--base-120);
  --background-color: var(--base-0);
  --border: 1px solid var(--base-30);
  --box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);
  --color-hover: var(--base-120);
  --background-color-hover: var(--base-10);
  --box-shadow-hover: 0 5px 15px rgba(0, 0, 0, 0.1);
  --color-focus: var(--base-120);
  --background-color-focus: var(--base-10);
  --box-shadow-focus: 0 5px 12px rgba(0, 0, 0, 0.1);
  --color-active: var(--base-120);
  --background-color-active: var(--base-20);
  --box-shadow-active: 0 5px 12px rgba(0, 0, 0, 0.1);
  --color-disabled: var(--base-60);
  --background-color-disabled: var(--base-20);
  --box-shadow-disabled: 0 5px 12px rgba(0, 0, 0, 0.1);
}

.FAB__theme-12-f710b9 {
  --border-radius: 50%;
  --color: var(--base-60);
  --background-color: var(--base-0);
  --color-hover: var(--base-80);
  --background-color-hover: var(--base-30);
  --color-focus: var(--base-80);
  --background-color-focus: var(--base-30);
  --color-active: var(--base-120);
  --background-color-active: var(--base-40);
  --color-disabled: var(--base-20);
  --background-color-disabled: var(--base-0);
}

.FAB__theme-12_1-d1defd {
  --border-radius: 50%;
  --color: var(--addition-50);
  --background-color: var(--addition-110_70);
  --color-hover: var(--addition-50);
  --background-color-hover: var(--addition-110_80);
  --color-focus: var(--addition-50);
  --background-color-focus: var(--addition-110_80);
  --color-active: var(--addition-50);
  --background-color-active: var(--addition-110_90);
  --color-disabled: var(--base-60);
  --background-color-disabled: var(--addition-110_70);
}

.FAB__theme-14-cdb950 {
  --border-radius: 50%;
  --color: var(--addition-50);
  --background-color: var(--brand-primary-40);
  --color-hover: var(--addition-50);
  --background-color-hover: var(--brand-primary-50);
  --color-focus: var(--addition-50);
  --background-color-focus: var(--brand-primary-50);
  --color-active: var(--addition-50);
  --background-color-active: var(--brand-primary-60);
  --color-disabled: var(--addition-60);
  --background-color-disabled: var(--brand-primary-20);
}

.FAB__theme-15-a6f81e {
  --border-radius: 50%;
  --color: var(--base-80);
  --background-color: transparent;
  --color-hover: var(--base-80);
  --background-color-hover: var(--base-20);
  --color-focus: var(--base-80);
  --background-color-focus: var(--base-20);
  --color-active: var(--base-80);
  --background-color-active: var(--base-30);
  --color-disabled: var(--base-40);
  --background-color-disabled: transparent;
}

.FAB__theme-16-c82cc5 {
  --border-radius: 50%;
  --color: var(--brand-primary-40);
  --background-color: transparent;
  --color-hover: var(--brand-primary-40);
  --background-color-hover: var(--base-20);
  --color-focus: var(--brand-primary-40);
  --background-color-focus: var(--base-20);
  --color-active: var(--brand-primary-40);
  --background-color-active: var(--base-30);
  --color-disabled: var(--brand-primary-20);
  --background-color-disabled: transparent;
}

.FAB__theme-17-e845c4 {
  --border-radius: 50%;
  --color: var(--brand-primary-40);
  --background-color: transparent;
  --color-hover: var(--brand-primary-50);
  --background-color-hover: transparent;
  --color-focus: var(--brand-primary-50);
  --background-color-focus: transparent;
  --color-active: var(--brand-primary-60);
  --background-color-active: transparent;
  --color-disabled: var(--brand-primary-20);
  --background-color-disabled: transparent;
}

.FAB__theme-21-d61224 {
  --border-radius: 12px;
  --color: var(--pattern-accent-50);
  --background-color: var(--brand-primary-40);
  --color-hover: var(--pattern-accent-50);
  --background-color-hover: var(--brand-primary-50);
  --color-focus: var(--pattern-accent-50);
  --background-color-focus: var(--brand-primary-50);
  --color-active: var(--pattern-accent-50);
  --background-color-active: var(--brand-primary-60);
  --color-disabled: var(--addition-60);
  --background-color-disabled: var(--brand-primary-10);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/FAB/FAB.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,UAAA;EAEA,mBAAA;EACA,yCAAA;EACA,qBAAA;EACA,6BAAA;EACA,qBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,+CAAA;EACA,mCAAA;AAAF;;AAGA;EACE;IACE,yBAAA;IACA,+CAAA;IACA,mCAAA;EAAF;AACF;AAGA;EACE,yBAAA;EACA,+CAAA;EACA,mCAAA;AADF;;AAIA;EACE,0BAAA;EACA,gDAAA;EACA,oCAAA;AADF;;AAIA;EACE,4BAAA;EACA,kDAAA;EACA,sCAAA;EACA,eAAA;EACA,8BAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,yBAAA;EACA,yCAAA;EACA,kCAAA;EACA,2BAAA;EACA,6CAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,oBAAA;EACA,gCAAA;EACA,+BAAA;EAEA,sCAAA;EACA,wCAAA;EAEA,sCAAA;EACA,wCAAA;EAEA,uCAAA;EACA,yCAAA;EAEA,yCAAA;EACA,wCAAA;AALF;;AAQA;;EAEE,oBAAA;EACA,wBAAA;EACA,iCAAA;EAEA,8BAAA;EACA,wCAAA;EAEA,8BAAA;EACA,wCAAA;EAEA,+BAAA;EACA,yCAAA;EAEA,gCAAA;EACA,0CAAA;AATF;;AAYA;EACE,+BAAA;AATF;;AAYA;;EAEE,oBAAA;EACA,wBAAA;EACA,kCAAA;EAEA,8BAAA;EACA,wCAAA;EAEA,8BAAA;EACA,wCAAA;EAEA,+BAAA;EACA,yCAAA;EAEA,gCAAA;EACA,0CAAA;AAbF;;AAgBA;EACE,oBAAA;EACA,2BAAA;EACA,uCAAA;EAEA,iCAAA;EACA,6CAAA;EAEA,iCAAA;EACA,6CAAA;EAEA,kCAAA;EACA,8CAAA;EAEA,uCAAA;EACA,0CAAA;AAjBF;;AAoBA;EACE,oBAAA;EACA,wBAAA;EACA,+BAAA;EAEA,8BAAA;EACA,wCAAA;EAEA,8BAAA;EACA,wCAAA;EAEA,+BAAA;EACA,yCAAA;EAEA,gCAAA;EACA,0CAAA;AArBF;;AAwBA;EACE,oBAAA;EACA,uBAAA;EACA,+BAAA;EAEA,8BAAA;EACA,qCAAA;EAEA,8BAAA;EACA,qCAAA;EAEA,+BAAA;EACA,sCAAA;EAEA,gCAAA;EACA,wCAAA;AAzBF;;AA4BA;EACE,oBAAA;EACA,gCAAA;EACA,+BAAA;EAEA,sCAAA;EACA,qCAAA;EAEA,sCAAA;EACA,qCAAA;EAEA,uCAAA;EACA,sCAAA;EAEA,yCAAA;EACA,wCAAA;AA7BF;;AAgCA;EACE,oBAAA;EACA,wBAAA;EACA,kCAAA;EAEA,8BAAA;EACA,wCAAA;EAEA,8BAAA;EACA,wCAAA;EAEA,+BAAA;EACA,yCAAA;EAEA,gCAAA;EACA,2CAAA;AAjCF;;AAoCA;EACE,oBAAA;EACA,wBAAA;EACA,iCAAA;EACA,kCAAA;EACA,2CAAA;EAEA,8BAAA;EACA,wCAAA;EACA,iDAAA;EAEA,8BAAA;EACA,wCAAA;EACA,iDAAA;EAEA,+BAAA;EACA,yCAAA;EACA,kDAAA;EAEA,gCAAA;EACA,2CAAA;EACA,oDAAA;AArCF;;AAwCA;EACE,oBAAA;EACA,uBAAA;EACA,iCAAA;EAEA,6BAAA;EACA,wCAAA;EAEA,6BAAA;EACA,wCAAA;EAEA,+BAAA;EACA,yCAAA;EAEA,gCAAA;EACA,0CAAA;AAzCF;;AA4CA;EACE,oBAAA;EACA,2BAAA;EACA,0CAAA;EAEA,iCAAA;EACA,gDAAA;EAEA,iCAAA;EACA,gDAAA;EAEA,kCAAA;EACA,iDAAA;EAEA,gCAAA;EACA,mDAAA;AA7CF;;AAgDA;EACE,oBAAA;EACA,2BAAA;EACA,2CAAA;EAEA,iCAAA;EACA,iDAAA;EAEA,iCAAA;EACA,iDAAA;EAEA,kCAAA;EACA,kDAAA;EAEA,oCAAA;EACA,oDAAA;AAjDF;;AAoDA;EACE,oBAAA;EACA,uBAAA;EACA,+BAAA;EAEA,6BAAA;EACA,wCAAA;EAEA,6BAAA;EACA,wCAAA;EAEA,8BAAA;EACA,yCAAA;EAEA,gCAAA;EACA,wCAAA;AArDF;;AAwDA;EACE,oBAAA;EACA,gCAAA;EACA,+BAAA;EAEA,sCAAA;EACA,wCAAA;EAEA,sCAAA;EACA,wCAAA;EAEA,uCAAA;EACA,yCAAA;EAEA,yCAAA;EACA,wCAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,gCAAA;EACA,+BAAA;EAEA,sCAAA;EACA,qCAAA;EAEA,sCAAA;EACA,qCAAA;EAEA,uCAAA;EACA,sCAAA;EAEA,yCAAA;EACA,wCAAA;AA7DF;;AAgEA;EACE,qBAAA;EACA,iCAAA;EACA,2CAAA;EAEA,uCAAA;EACA,iDAAA;EAEA,uCAAA;EACA,iDAAA;EAEA,wCAAA;EACA,kDAAA;EAEA,oCAAA;EACA,oDAAA;AAjEF","sourcesContent":[".container {\n  cursor: pointer;\n  position: relative;\n  box-sizing: border-box;\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--border-radius);\n  padding: 0;\n\n  color: var(--color);\n  background-color: var(--background-color);\n  border: var(--border);\n  box-shadow: var(--box-shadow);\n  text-decoration: none;\n}\n\n.container:hover {\n  color: var(--color-hover);\n  background-color: var(--background-color-hover);\n  box-shadow: var(--box-shadow-hover);\n}\n\n@supports (display: block) {\n  .container:focus-visible {\n    color: var(--color-focus);\n    background-color: var(--background-color-focus);\n    box-shadow: var(--box-shadow-focus);\n  }\n}\n\n.container:focus-within {\n  color: var(--color-focus);\n  background-color: var(--background-color-focus);\n  box-shadow: var(--box-shadow-focus);\n}\n\n.container:active {\n  color: var(--color-active);\n  background-color: var(--background-color-active);\n  box-shadow: var(--box-shadow-active);\n}\n\n.container:disabled {\n  color: var(--color-disabled);\n  background-color: var(--background-color-disabled);\n  box-shadow: var(--box-shadow-disabled);\n  cursor: default;\n  border: var(--border-disabled);\n}\n\n.badge {\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  color: var(--addition-50);\n  background-color: var(--brand-primary-40);\n  transition: border-color 0.3s ease;\n  font: var(--font-caption-1);\n  letter-spacing: var(--font-spacing-caption-1);\n  display: inline-block;\n  line-height: 24px;\n  text-align: center;\n}\n\n.icon {\n  fill: currentColor;\n}\n\n:root[dir='rtl'] .icon {\n  transform: scaleX(-1);\n}\n\n.size-0 {\n  width: 24px;\n  height: 24px;\n}\n\n.icon-size-0 svg {\n  width: 16px;\n  height: 16px;\n}\n\n.size-10 {\n  width: 32px;\n  height: 32px;\n}\n\n.icon-size-10 svg {\n  width: 24px;\n  height: 24px;\n}\n\n.size-20 {\n  width: 36px;\n  height: 36px;\n}\n\n.icon-size-20 svg {\n  width: 24px;\n  height: 24px;\n}\n\n.size-30 {\n  width: 40px;\n  height: 40px;\n}\n\n.icon-size-30 svg {\n  width: 24px;\n  height: 24px;\n}\n\n.size-40 {\n  width: 48px;\n  height: 48px;\n}\n\n.icon-size-40 svg {\n  width: 24px;\n  height: 24px;\n}\n\n.size-50 {\n  width: 52px;\n  height: 52px;\n}\n\n.icon-size-50 svg {\n  width: 24px;\n  height: 24px;\n}\n\n.size-60 {\n  width: 64px;\n  height: 64px;\n}\n\n.icon-size-60 svg {\n  width: 32px;\n  height: 32px;\n}\n\n.theme-1 {\n  --border-radius: 50%;\n  --color: var(--brand-primary-40);\n  --background-color: transparent;\n\n  --color-hover: var(--brand-primary-40);\n  --background-color-hover: var(--base-20);\n\n  --color-focus: var(--brand-primary-40);\n  --background-color-focus: var(--base-20);\n\n  --color-active: var(--brand-primary-50);\n  --background-color-active: var(--base-30);\n\n  --color-disabled: var(--brand-primary-20);\n  --background-color-disabled: transparent;\n}\n\n.theme-2,\n.theme-8 {\n  --border-radius: 50%;\n  --color: var(--base-120);\n  --background-color: var(--base-0);\n\n  --color-hover: var(--base-120);\n  --background-color-hover: var(--base-20);\n\n  --color-focus: var(--base-120);\n  --background-color-focus: var(--base-20);\n\n  --color-active: var(--base-120);\n  --background-color-active: var(--base-30);\n\n  --color-disabled: var(--base-40);\n  --background-color-disabled: var(--base-0);\n}\n\n.theme-2 {\n  --background-color: transparent;\n}\n\n.theme-2_1,\n.theme-8_1 {\n  --border-radius: 50%;\n  --color: var(--base-120);\n  --background-color: var(--base-30);\n\n  --color-hover: var(--base-120);\n  --background-color-hover: var(--base-20);\n\n  --color-focus: var(--base-120);\n  --background-color-focus: var(--base-20);\n\n  --color-active: var(--base-120);\n  --background-color-active: var(--base-30);\n\n  --color-disabled: var(--base-40);\n  --background-color-disabled: var(--base-0);\n}\n\n.theme-2_i {\n  --border-radius: 50%;\n  --color: var(--addition-50);\n  --background-color: var(--addition-110);\n\n  --color-hover: var(--addition-50);\n  --background-color-hover: var(--addition-110);\n\n  --color-focus: var(--addition-50);\n  --background-color-focus: var(--addition-110);\n\n  --color-active: var(--addition-50);\n  --background-color-active: var(--addition-110);\n\n  --color-disabled: var(--addition-50_50);\n  --background-color-disabled: var(--base-0);\n}\n\n.theme-3 {\n  --border-radius: 50%;\n  --color: var(--base-120);\n  --background-color: transparent;\n\n  --color-hover: var(--base-120);\n  --background-color-hover: var(--base-20);\n\n  --color-focus: var(--base-120);\n  --background-color-focus: var(--base-20);\n\n  --color-active: var(--base-120);\n  --background-color-active: var(--base-30);\n\n  --color-disabled: var(--base-40);\n  --background-color-disabled: var(--base-0);\n}\n\n.theme-3_1 {\n  --border-radius: 50%;\n  --color: var(--base-80);\n  --background-color: transparent;\n\n  --color-hover: var(--base-100);\n  --background-color-hover: transparent;\n\n  --color-focus: var(--base-100);\n  --background-color-focus: transparent;\n\n  --color-active: var(--base-120);\n  --background-color-active: transparent;\n\n  --color-disabled: var(--base-60);\n  --background-color-disabled: transparent;\n}\n\n.theme-3_2 {\n  --border-radius: 50%;\n  --color: var(--brand-primary-40);\n  --background-color: transparent;\n\n  --color-hover: var(--brand-primary-50);\n  --background-color-hover: transparent;\n\n  --color-focus: var(--brand-primary-50);\n  --background-color-focus: transparent;\n\n  --color-active: var(--brand-primary-60);\n  --background-color-active: transparent;\n\n  --color-disabled: var(--brand-primary-10);\n  --background-color-disabled: transparent;\n}\n\n.theme-6 {\n  --border-radius: 50%;\n  --color: var(--base-120);\n  --background-color: var(--base-20);\n\n  --color-hover: var(--base-120);\n  --background-color-hover: var(--base-30);\n\n  --color-focus: var(--base-120);\n  --background-color-focus: var(--base-30);\n\n  --color-active: var(--base-120);\n  --background-color-active: var(--base-40);\n\n  --color-disabled: var(--base-60);\n  --background-color-disabled: var(--base-20);\n}\n\n.theme-7 {\n  --border-radius: 50%;\n  --color: var(--base-120);\n  --background-color: var(--base-0);\n  --border: 1px solid var(--base-30);\n  --box-shadow: 0 5px 12px rgba(0, 0, 0, 0.1);\n\n  --color-hover: var(--base-120);\n  --background-color-hover: var(--base-10);\n  --box-shadow-hover: 0 5px 15px rgba(0, 0, 0, 0.1);\n\n  --color-focus: var(--base-120);\n  --background-color-focus: var(--base-10);\n  --box-shadow-focus: 0 5px 12px rgba(0, 0, 0, 0.1);\n\n  --color-active: var(--base-120);\n  --background-color-active: var(--base-20);\n  --box-shadow-active: 0 5px 12px rgba(0, 0, 0, 0.1);\n\n  --color-disabled: var(--base-60);\n  --background-color-disabled: var(--base-20);\n  --box-shadow-disabled: 0 5px 12px rgba(0, 0, 0, 0.1);\n}\n\n.theme-12 {\n  --border-radius: 50%;\n  --color: var(--base-60);\n  --background-color: var(--base-0);\n\n  --color-hover: var(--base-80);\n  --background-color-hover: var(--base-30);\n\n  --color-focus: var(--base-80);\n  --background-color-focus: var(--base-30);\n\n  --color-active: var(--base-120);\n  --background-color-active: var(--base-40);\n\n  --color-disabled: var(--base-20);\n  --background-color-disabled: var(--base-0);\n}\n\n.theme-12_1 {\n  --border-radius: 50%;\n  --color: var(--addition-50);\n  --background-color: var(--addition-110_70);\n\n  --color-hover: var(--addition-50);\n  --background-color-hover: var(--addition-110_80);\n\n  --color-focus: var(--addition-50);\n  --background-color-focus: var(--addition-110_80);\n\n  --color-active: var(--addition-50);\n  --background-color-active: var(--addition-110_90);\n\n  --color-disabled: var(--base-60);\n  --background-color-disabled: var(--addition-110_70);\n}\n\n.theme-14 {\n  --border-radius: 50%;\n  --color: var(--addition-50);\n  --background-color: var(--brand-primary-40);\n\n  --color-hover: var(--addition-50);\n  --background-color-hover: var(--brand-primary-50);\n\n  --color-focus: var(--addition-50);\n  --background-color-focus: var(--brand-primary-50);\n\n  --color-active: var(--addition-50);\n  --background-color-active: var(--brand-primary-60);\n\n  --color-disabled: var(--addition-60);\n  --background-color-disabled: var(--brand-primary-20);\n}\n\n.theme-15 {\n  --border-radius: 50%;\n  --color: var(--base-80);\n  --background-color: transparent;\n\n  --color-hover: var(--base-80);\n  --background-color-hover: var(--base-20);\n\n  --color-focus: var(--base-80);\n  --background-color-focus: var(--base-20);\n\n  --color-active: var(--base-80);\n  --background-color-active: var(--base-30);\n\n  --color-disabled: var(--base-40);\n  --background-color-disabled: transparent;\n}\n\n.theme-16 {\n  --border-radius: 50%;\n  --color: var(--brand-primary-40);\n  --background-color: transparent;\n\n  --color-hover: var(--brand-primary-40);\n  --background-color-hover: var(--base-20);\n\n  --color-focus: var(--brand-primary-40);\n  --background-color-focus: var(--base-20);\n\n  --color-active: var(--brand-primary-40);\n  --background-color-active: var(--base-30);\n\n  --color-disabled: var(--brand-primary-20);\n  --background-color-disabled: transparent;\n}\n\n.theme-17 {\n  --border-radius: 50%;\n  --color: var(--brand-primary-40);\n  --background-color: transparent;\n\n  --color-hover: var(--brand-primary-50);\n  --background-color-hover: transparent;\n\n  --color-focus: var(--brand-primary-50);\n  --background-color-focus: transparent;\n\n  --color-active: var(--brand-primary-60);\n  --background-color-active: transparent;\n\n  --color-disabled: var(--brand-primary-20);\n  --background-color-disabled: transparent;\n}\n\n.theme-21 {\n  --border-radius: 12px;\n  --color: var(--pattern-accent-50);\n  --background-color: var(--brand-primary-40);\n\n  --color-hover: var(--pattern-accent-50);\n  --background-color-hover: var(--brand-primary-50);\n\n  --color-focus: var(--pattern-accent-50);\n  --background-color-focus: var(--brand-primary-50);\n\n  --color-active: var(--pattern-accent-50);\n  --background-color-active: var(--brand-primary-60);\n\n  --color-disabled: var(--addition-60);\n  --background-color-disabled: var(--brand-primary-10);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FAB__container-f5fb6b`,
	"badge": `FAB__badge-abd503`,
	"icon": `FAB__icon-e8966d`,
	"size-0": `FAB__size-0-b42b1c`,
	"size0": `FAB__size-0-b42b1c`,
	"icon-size-0": `FAB__icon-size-0-ef0fa9`,
	"iconSize0": `FAB__icon-size-0-ef0fa9`,
	"size-10": `FAB__size-10-f5b024`,
	"size10": `FAB__size-10-f5b024`,
	"icon-size-10": `FAB__icon-size-10-dc3786`,
	"iconSize10": `FAB__icon-size-10-dc3786`,
	"size-20": `FAB__size-20-aabbfc`,
	"size20": `FAB__size-20-aabbfc`,
	"icon-size-20": `FAB__icon-size-20-cce7b5`,
	"iconSize20": `FAB__icon-size-20-cce7b5`,
	"size-30": `FAB__size-30-a1d052`,
	"size30": `FAB__size-30-a1d052`,
	"icon-size-30": `FAB__icon-size-30-e52a78`,
	"iconSize30": `FAB__icon-size-30-e52a78`,
	"size-40": `FAB__size-40-a845c2`,
	"size40": `FAB__size-40-a845c2`,
	"icon-size-40": `FAB__icon-size-40-e83670`,
	"iconSize40": `FAB__icon-size-40-e83670`,
	"size-50": `FAB__size-50-b14226`,
	"size50": `FAB__size-50-b14226`,
	"icon-size-50": `FAB__icon-size-50-d57319`,
	"iconSize50": `FAB__icon-size-50-d57319`,
	"size-60": `FAB__size-60-bf9848`,
	"size60": `FAB__size-60-bf9848`,
	"icon-size-60": `FAB__icon-size-60-ad2cee`,
	"iconSize60": `FAB__icon-size-60-ad2cee`,
	"theme-1": `FAB__theme-1-d5f50f`,
	"theme1": `FAB__theme-1-d5f50f`,
	"theme-2": `FAB__theme-2-b15042`,
	"theme2": `FAB__theme-2-b15042`,
	"theme-8": `FAB__theme-8-ce1bc2`,
	"theme8": `FAB__theme-8-ce1bc2`,
	"theme-2_1": `FAB__theme-2_1-a90f20`,
	"theme21": `FAB__theme-2_1-a90f20`,
	"theme-8_1": `FAB__theme-8_1-a66eab`,
	"theme81": `FAB__theme-8_1-a66eab`,
	"theme-2_i": `FAB__theme-2_i-c1681b`,
	"theme2I": `FAB__theme-2_i-c1681b`,
	"theme-3": `FAB__theme-3-ce1c66`,
	"theme3": `FAB__theme-3-ce1c66`,
	"theme-3_1": `FAB__theme-3_1-c75193`,
	"theme31": `FAB__theme-3_1-c75193`,
	"theme-3_2": `FAB__theme-3_2-f32996`,
	"theme32": `FAB__theme-3_2-f32996`,
	"theme-6": `FAB__theme-6-b87e82`,
	"theme6": `FAB__theme-6-b87e82`,
	"theme-7": `FAB__theme-7-f8af48`,
	"theme7": `FAB__theme-7-f8af48`,
	"theme-12": `FAB__theme-12-f710b9`,
	"theme12": `FAB__theme-12-f710b9`,
	"theme-12_1": `FAB__theme-12_1-d1defd`,
	"theme121": `FAB__theme-12_1-d1defd`,
	"theme-14": `FAB__theme-14-cdb950`,
	"theme14": `FAB__theme-14-cdb950`,
	"theme-15": `FAB__theme-15-a6f81e`,
	"theme15": `FAB__theme-15-a6f81e`,
	"theme-16": `FAB__theme-16-c82cc5`,
	"theme16": `FAB__theme-16-c82cc5`,
	"theme-17": `FAB__theme-17-e845c4`,
	"theme17": `FAB__theme-17-e845c4`,
	"theme-21": `FAB__theme-21-d61224`,
	"theme21": `FAB__theme-21-d61224`
};
module.exports = ___CSS_LOADER_EXPORT___;
